import { renderScreen } from '../../actions/drawerActions';
import { nameLabels, ScreenTypes } from '../../helpers/Constants';
import strings from '../../localization';
import { useAppDispatch } from '../useAppDispatch';

type actionsParams = {
  pharmacistId: string;
  pharmacyId: string;
  isAutoSyncRecord: boolean;
};

const actions = (goToNotes: () => void, goToHistory: () => void) =>
  [
    {
      key: '1',
      onClick: goToHistory,
      label: strings.history,
    },
    {
      key: '2',
      onClick: goToNotes,
      label: `${nameLabels().roleLabel} ${strings.notes}`,
    },
  ];

const useListOfPharmacies = () => {
  const dispatch = useAppDispatch();

  const goToHistory = (params: actionsParams) =>
    () => {
      dispatch(
        renderScreen({
          screenType: ScreenTypes.pharmacistList,
          screenNumber: 6,
          extraParameters: {
            isAutoSyncRecord: params.isAutoSyncRecord,
          },
          ...params,
        }),
      );
    };

  const goToNotes = (params: actionsParams) =>
    () => {
      dispatch(
        renderScreen({
          screenType: ScreenTypes.pharmacistList,
          screenNumber: 7,
          extraParameters: {
            isAutoSyncRecord: params.isAutoSyncRecord,
          },
          ...params,
        }),
      );
    };

  return {
    menuAction: (params: actionsParams) =>
      actions(goToNotes(params), goToHistory(params)),
  };
};

export default useListOfPharmacies;
